<script>
  import { navigateI18n } from "../../../i18n/navigate.js";
  import { getNotificationsContext } from "svelte-notifications"
  import StepBase from "./StepBase.svelte";
  import ConfirmationStepDataCard from "./confirmationStep/ConfirmationStepDataCard.svelte";
  import Button from "../../../components/button/Button.svelte";
  import { getAutoMpsProjectContext } from "../../AutoMpsProjectContext.js";
  import {localizeImportedAt} from "./importStep/parts/tableUtils.js";
  import Message from "./parts/Message.svelte";

  export let onClickBack
  export let moveNext

  export let plan

  const ctx = getAutoMpsProjectContext()

  const {addNotification} = getNotificationsContext()
  let isExecuting = false

  async function onClickLevelLoads(parameterName) {
    isExecuting = true
    const response = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/plans/${plan.meta.id}/dispatch`, {
      method: "POST",
      body: JSON.stringify({
        parameterName,
      }),
      headers: {
        "Content-Type": "application/json",
      }
    })
    const responseData = await response.json().catch(() => ({}))
    if (response.ok) {
      moveNext(responseData.id)
    } else {
      addNotification({
        position: "top-right",
        type: "error",
        removeAfter: 4000,
        text: `実行の予約に失敗しました。(${responseData.errorCode ?? "エラーコード不明"})`
      })
    }
    isExecuting = false
  }
</script>

<StepBase onClickBack={onClickBack}>
  {#if isExecuting}
    <div style="width: 100%; height: 100%; display: grid; place-items: center">
      <div>
        Asprova AutoMPS を使用して負荷の平準化を行っています...
      </div>
    </div>
  {:else}
    <div style="margin: 1rem">
      データに問題がないことを確認して、平準化を実行しましょう。
      <div style="display: flex; justify-content: center">
        <Button size="large" onClick={() => onClickLevelLoads("main")}>
          平準化を実行する
        </Button>
      </div>
    </div>
    <div style="background-color: lightgrey; height: 2px" />
    <div style="display: grid; grid-template-columns: 1fr 2px 1fr; gap: 3rem; margin: 3rem 1rem">
      <div style="display: flex; flex-direction: column; gap: 1rem;">
        <ConfirmationStepDataCard title="①: 受注データ" dataType={"demand"} importId={plan.data.demand.meta.id}>
          <span style="color: #3b5f3c">✔ {localizeImportedAt(plan.data.demand.meta.importedAt)}のデータが使用されます</span>
        </ConfirmationStepDataCard>
        <ConfirmationStepDataCard title="②: 品目データ" dataType={"item"} importId={plan.data.item.meta.id}>
          <Message type="success">
            ✔ {localizeImportedAt(plan.data.item.meta.importedAt)} のデータが使用されます
          </Message>
        </ConfirmationStepDataCard>
        <ConfirmationStepDataCard title="③: 在庫データ" dataType={"inventory"} importId={plan.data.inventory.meta.id}>
          <span style="color: #3b5f3c">✔ {localizeImportedAt(plan.data.inventory.meta.importedAt)} のデータが使用されます</span>
        </ConfirmationStepDataCard>
        <ConfirmationStepDataCard title="④: 製造データ" dataType={"production"} importId={plan.data.production.meta.id}>
          <span style="color: #3b5f3c">✔ {localizeImportedAt(plan.data.production.meta.importedAt)} のデータが使用されます</span>
        </ConfirmationStepDataCard>
        <ConfirmationStepDataCard title="⑤: カレンダデータ" dataType={"calendar"} importId={plan.data.calendar.meta.id}>
          <span style="color: #3b5f3c">✔ {localizeImportedAt(plan.data.calendar.meta.importedAt)} のデータが使用されます</span>
        </ConfirmationStepDataCard>
        <ConfirmationStepDataCard title="⑥: シフトデータ" dataType={"shift"} importId={plan.data.shift.meta.id}>
          <span style="color: #3b5f3c">✔ {localizeImportedAt(plan.data.shift.meta.importedAt)} のデータが使用されます</span>
        </ConfirmationStepDataCard>
      </div>
      <div style="background-color: lightgrey;"></div>
      <div>
        <ConfirmationStepDataCard title="パラメータデータ" dataType={"parameter"} importId={plan.data.parameter.meta.id}>
          <span style="color: #3b5f3c">✔ {localizeImportedAt(plan.data.parameter.meta.importedAt)} のデータが使用されます</span>
        </ConfirmationStepDataCard>
      </div>
    </div>
  {/if}
</StepBase>
